import { env } from '@/config/env';
import { initI18n } from '@nablax/i18n';

initI18n(
  env.VITE_BUILD_BASE_PATH,
  env.VITE_DEV_MODE,
  ['spaiderdemo', 'customer'],
  'spaiderdemo',
);
